import { render, staticRenderFns } from "./DrawerList.vue?vue&type=template&id=37ff5fda&scoped=true"
import script from "./DrawerList.vue?vue&type=script&lang=js"
export * from "./DrawerList.vue?vue&type=script&lang=js"
import style0 from "./DrawerList.vue?vue&type=style&index=0&id=37ff5fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ff5fda",
  null
  
)

export default component.exports